export default function RadioButton({
  type = 'radio',
  name,
  value,
  checked = false,
  onChange,
  label,
  className = '',
  labelClassName = '',
}) {
  return (
    <label className={`inline-flex cursor-pointer items-center gap-2 ${className}`}>
      <input
        type={type}
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        className="peer sr-only"
      />
      <span className="relative inline-block h-5 w-5 rounded-full border border-[#9fa7b5] bg-white transition peer-focus-visible:ring-2 peer-focus-visible:ring-[#d7dce4] peer-checked:before:absolute peer-checked:before:left-1/2 peer-checked:before:top-1/2 peer-checked:before:h-2.5 peer-checked:before:w-2.5 peer-checked:before:-translate-x-1/2 peer-checked:before:-translate-y-1/2 peer-checked:before:rounded-full peer-checked:before:bg-bg_primary peer-checked:before:content-['']" />
      <span className={labelClassName}>{label}</span>
    </label>
  );
}
